import React, { useState } from 'react';
import api from '../api';
import { useNavigate } from 'react-router-dom';
import bg from '../assests/bg.jpg';

const RegisterForm = () => {
    const [formData, setFormData] = useState({
        email: '',
        phoneNo: '',
        password: '',
    });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post('/admin/signup', formData);
            setSuccess('Registration successful!');
            setError('');
            setFormData({
                email: '',
                phoneNo: '',
                password: '',
            });
        } catch (err) {
            setError('Registration failed. Please try again.');
            setSuccess('');
        }
    };

    const handleLoginClick = () => {
        navigate('/'); 
    };

    return (
        <div
            className="container-fluid d-flex align-items-center justify-content-center auth-container"
            style={{
                background: 'radial-gradient(circle at center, #1c2541 0%, #0a1128 100%)',
                height: '100vh',
            }}
        >
            <div
                className="card shadow-lg"
                style={{
                    backgroundColor: 'rgba(10, 17, 40, 0.85)',
                    backdropFilter: 'blur(12px)',
                    WebkitBackdropFilter: 'blur(12px)',
                    border: '1px solid rgba(197, 160, 89, 0.25)',
                    color: '#ffffff',
                    maxWidth: '900px',
                    width: '100%',
                    borderRadius: '16px',
                    overflow: 'hidden',
                }}
            >
                <div className="row g-0">
                    {/* Left Side: ACCI Logo */}
                    <div 
                        className="col-md-6 d-none d-md-flex flex-column align-items-center justify-content-center p-5"
                        style={{
                            borderRight: '1px solid rgba(197, 160, 89, 0.15)',
                            background: 'linear-gradient(135deg, rgba(28, 37, 65, 0.5) 0%, rgba(10, 17, 40, 0.5) 100%)',
                        }}
                    >
                        <div style={{
                            width: '240px',
                            height: '240px',
                            borderRadius: '50%',
                            background: 'radial-gradient(circle, rgba(197,160,89,0.15) 0%, rgba(0,0,0,0) 70%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '20px',
                        }}>
                            <img 
                                src="/logo.png" 
                                alt="ACCI Logo" 
                                style={{ 
                                    maxWidth: '200px', 
                                    maxHeight: '200px', 
                                    objectFit: 'contain',
                                    filter: 'drop-shadow(0 0 15px rgba(197, 160, 89, 0.45))'
                                }} 
                            />
                        </div>
                        <h3 style={{ 
                            color: '#c5a059', 
                            fontWeight: '700', 
                            margin: 0, 
                            letterSpacing: '2px',
                            fontSize: '22px',
                            textAlign: 'center'
                        }}>
                            ACCI PORTAL
                        </h3>
                        <p style={{ 
                            color: '#cbd5e1', 
                            fontSize: '13px', 
                            marginTop: '8px', 
                            textAlign: 'center',
                            opacity: 0.8
                        }}>
                            Agamudayar Chamber of Commerce & Industries
                        </p>
                    </div>

                    {/* Right Side: Register Form */}
                    <div className="col-md-6 col-12 p-4 p-md-5 d-flex flex-column justify-content-center">
                        <h2 className="mb-4 text-center" style={{ color: '#c5a059', fontWeight: '700', letterSpacing: '1px' }}>REGISTER</h2>
                        {error && <div className="alert alert-danger">{error}</div>}
                        {success && <div className="alert alert-success">{success}</div>}
                        <form onSubmit={handleSubmit}>
                            <div className="form-group mb-3">
                                <label htmlFor="email" style={{ color: '#cbd5e1', fontSize: '14px', marginBottom: '6px' }}>Email:</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    className="form-control"
                                    value={formData.email}
                                    onChange={handleChange}
                                    autoComplete='off'
                                    required
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label htmlFor="phoneNo" style={{ color: '#cbd5e1', fontSize: '14px', marginBottom: '6px' }}>Phone Number:</label>
                                <input
                                    type="text"
                                    id="phoneNo"
                                    name="phoneNo"
                                    className="form-control"
                                    value={formData.phoneNo}
                                    onChange={handleChange}
                                    autoComplete='off'
                                    required
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label htmlFor="password" style={{ color: '#cbd5e1', fontSize: '14px', marginBottom: '6px' }}>Password:</label>
                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    className="form-control"
                                    value={formData.password}
                                    onChange={handleChange}
                                    autoComplete='off'
                                    required
                                />
                            </div>
                            <div className="d-flex flex-column mt-4">
                                <button type="submit" className="btn btn-success mb-2 py-2" style={{ fontWeight: 600 }}>SignUp</button>
                                <button type="button" className="btn btn-primary py-2" onClick={handleLoginClick} style={{ fontWeight: 600 }}>
                                    Login
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisterForm;
